import { createQueryHook } from '@hooks/createQueryHook'
import { createMutationHook } from '@hooks/createMutationHook'

// Active/available tournaments. Component passes { tournamentStatus, page, pageSize }.
export const useTournaments = createQueryHook('tournaments.list')

// Past tournaments. Component passes { page, pageSize }.
export const useTournamentsHistory = createQueryHook('tournaments.history')

// Active leaderboard. Component passes { tournamentId, page, pageSize }.
export const useTournamentLeaderboard = createQueryHook('tournaments.leaderboard')

// Past leaderboard. Component passes { tournamentId, page, pageSize }.
export const useTournamentLeaderboardHistory = createQueryHook('tournaments.leaderboardHistory')

// Prize table for a tournament. Component passes { tournamentId }.
export const useTournamentPrizes = createQueryHook('tournaments.prizes')

// Opt in/out (mutation). Refreshes tournaments on success.
// Usage: const { mutate } = useTournamentOptIn(); mutate({ tournamentId, optInStatus })
export const useTournamentOptIn = createMutationHook('tournaments.optIn')
